import {post} from './http'
const basturl = '/api/capwhale/live/video'


// 内容发表评论操作
export const addCommentInfo = v => post(`${basturl}/addCommentInfo`, v.data, v.success, v.error)

// 获取直播详情
export const getAliveProductDetail = v => post(`${basturl}/getAliveProductDetail`, v.data, v.success, v.error)

// 获取直播状态
export const getAliveStatus = v => post(`${basturl}/getAliveStatus`, v.data, v.success, v.error)

// 获取内容评论列表(直播私信模式)
export const getLiveCommentList = v => post(`${basturl}/getLiveCommentList`, v.data, v.success, v.error)

// 获取最新内容评论列表(直播私信模式)
export const getLiveNewCommentList = v => post(`${basturl}/getLiveNewCommentList`, v.data, v.success, v.error)

// 获取直播详情的分页图片集
export const getMaterialImageList = v => post(`${basturl}/getMaterialImageList`, v.data, v.success, v.error)

// 获取直播详情的分页视频集
export const getMaterialVideoList = v => post(`${basturl}/getMaterialVideoList`, v.data, v.success, v.error)

// 点赞
export const addPraiseInfo = v => post(`${basturl}/addPraiseInfo`, v.data, v.success, v.error)

// 获取海报
export const getVliveEventposter = v => post(`${basturl}/getVliveEventposter`, v.data, v.success, v.error)